import { Container, Title } from "./PageHero.styled";

interface TitleProps {
    title: string;
    description?: string;
    children?: JSX.Element | Array<JSX.Element>;
}

function PageHero({
    title = "",
    description = "",
    children
}: TitleProps): JSX.Element {
    return (
        <Container>
            <Title>{title}</Title>
            <p>{description}</p>
            {children}
        </Container>
    );
}

export default PageHero;
